import { createFileRoute, Outlet } from '@tanstack/react-router';
import { DataConnectorHeader } from '../../-components/DataConnectorHeader';
export const Route = createFileRoute('/_staff/settings/data-connector/outbound/data-pipeline/_list')({
  component: OutboundDataPipelineLayout
});
function OutboundDataPipelineLayout() {
  return <div className="flex flex-col">
      <DataConnectorHeader section="outbound" />
      <Outlet />
    </div>;
}